<template>
  <div class="footer-pc" :style="{ position: appInfo.hasScrollbar ? 'static' : 'fixed' }">
    <span>湘ICP备2023037219号</span>
    <span>岳麓山工业创新中心(实验室)版权所有</span>
  </div>
</template>

<script>
export default {
  inject: ['appInfo'],
};
</script>

<style lang="scss" scoped>
.footer-pc {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #03316B;
  font-size: 14px;
  color: #FFFFFF;
  font-weight: 400;
  gap: 20px;
  bottom: 0;
}
</style>
